import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface LendAndReturnConditionUserLimit {
  id: number
  branchCode: SystemCode
  lendType: SystemCode
  userType: SystemCode
  numberOfTotalBooks: number
  numberOfLatestBooks: number
  revision: number
}

export const defaultLendAndReturnConditionUserLimit = (): LendAndReturnConditionUserLimit => ({
  id: 0,
  branchCode: defaultSystemCode(),
  lendType: defaultSystemCode(),
  userType: defaultSystemCode(),
  numberOfTotalBooks: 0,
  numberOfLatestBooks: 0,
  revision: 0
})

export function LendAndReturnConditionUserLimitFromJSON(
  json: any
): LendAndReturnConditionUserLimit {
  return {
    id: exists(json, 'id') ? json.id : 0,
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    lendType: exists(json, 'lend_type')
      ? SystemCodeFromJSON(json.lend_type)
      : defaultSystemCode(),
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    numberOfTotalBooks: exists(json, 'number_of_total_books')
      ? json.number_of_total_books
      : 0,
    numberOfLatestBooks: exists(json, 'number_of_latest_books')
      ? json.number_of_latest_books
      : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
